import React, { Component } from 'react';
import { PlaceItemInfo } from './PlaceItemInfo';

export class ScanPutawayBin extends Component {

    constructor(props) {
        super(props);
        console.log("BIN PROPS", this.props);
    }

    render() {
        return (
            <div>
                <button onClick={this.props.goBackToItems}>Back to Items</button>
                <PlaceItemInfo
                    putawayBin={this.props.putawayBin}
                    putawayItem={this.props.putawayItem}
                    scanPutawayBin={this.props.scanPutawayBin}
                    focusInput={this.props.focusInput}
                    updateInputValue={this.props.updateInputValue}
                    updateQuantity={this.props.updateQuantity}
                    putawayQty={this.props.putawayQty}
                />
            </div>
        );
    }
}